import React from 'react';
import './Spinner.scss';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'blue' | 'pink' | 'gray' | 'white';
  centered?: boolean;
  overlay?: boolean;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  color = 'blue',
  centered = false,
  overlay = false,
  className = ''
}) => {
  const spinnerClasses = [
    'spinner',
    `spinner--${ size }`,
    `spinner--${ color }`,
    centered ? 'spinner--centered' : '',
    className
  ].filter(Boolean).join(' ');

  const spinnerElement = (
    <div className={ spinnerClasses } role="status" aria-label="Loading">
      <div className="spinner__circle"></div>
    </div>
  );

  if (overlay) {
    return (
      <div style={ {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 9999
      } }>
        { spinnerElement }
      </div>
    );
  }

  return spinnerElement;
};

export default Spinner;
